export default "__VITE_ASSET__ChvwXKzH__"